import { getInjection } from '@/di/inversify.config';
import { Result } from '@/entities/Result';
import { StatesResponse } from '@/infrastructure/network/dto/StateDto';

export const getStatesUseCase = async (countryId?: string): Promise<Result<StatesResponse>> => {
	const statesRepository = getInjection('IStatesRepository');
	return statesRepository.getStates(countryId);
};
